<!-- Author- Renuka chama
  16/03/2026
  For creation of  JSuite object popup screen -->

<div class="topDiv">
    <div class="mainContent">

        <div style="height: 7vh;">
            <div>
                <label i18n="@@spmsUserReg" class="textColour">JSuite Objects</label>
                <span class="example-spacer"></span>
            </div>
        </div>

        <div style="padding:0 20px;">
            <form novalidate [formGroup]="FormValid" style="width: 100%;">

                <!-- Object Name -->
                <div class="row">
                    <div class="col-lg" style="margin-top: 10px;">
                        <mat-form-field appearance="outline">
                            <mat-label>Object Name</mat-label>
                            <input matInput type="text" placeholder="Object Name" formControlName="objectName"
                                [(ngModel)]="jsuiteObjects.objectName" required readonly>
                            <mat-error *ngFor="let validation of
                  validation_messages.objectName">
                                <span *ngIf="FormValid.get('objectName').hasError(validation.type)
                    && (FormValid.get('objectName').dirty ||
                    FormValid.get('objectName').touched)">
                                    {{ validation.message }}
                                </span>
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>



                <div class="row">
                    <div class="col-lg" style="margin-top: 10px;">
                        <mat-form-field appearance="outline">
                            <mat-label>Object Type</mat-label>
                            <mat-select formControlName="objectType" [(ngModel)]="jsuiteObjects.objectType"
                                (selectionChange)="onObjectTypeChange($event.value)" required>

                                <mat-option *ngFor="let item of objectTypeList" [value]="item.lookupvalueid"> {{
                                    item.lookupvalue }}
                                </mat-option>

                            </mat-select>
                            <mat-error *ngFor="let validation of
                                      validation_messages.objectType">
                                <span *ngIf="FormValid.get('objectType').hasError(validation.type)
                                        && (FormValid.get('objectType').dirty ||
                                        FormValid.get('objectType').touched)">
                                    {{ validation.message }}
                                </span>
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg" style="margin-top: 10px;">
                        <div style="justify-content: space-between; max-width: 100%;">
                            <mat-form-field appearance="outline" style="width: 92%;margin-right: 3%;">

                                <mat-label>Attributes</mat-label>
                                <textarea matInput type="text" placeholder="Attributes" formControlName="attributes"
                                    [(ngModel)]="jsuiteObjects.attributes" readonly>
                                </textarea>
                                <mat-error *ngFor="let validation of
                  validation_messages.attributes">
                                <span *ngIf="FormValid.get('attributes').hasError(validation.type)
                    && (FormValid.get('attributes').dirty ||
                    FormValid.get('attributes').touched)">
                                    {{ validation.message }}
                                </span>
                            </mat-error>


                            </mat-form-field>

                            <label *ngIf="!isEditMode" (click)="openAttributePopup(jsuiteObjects)"
                                [style.background-color]="backgroundColorButton"
                                style="margin-top:6px; padding:2px 5px; border-radius:15px; cursor:pointer;">

                                <em class="fas fa-plus" style="color:antiquewhite;font-size:large;"
                                    title="Add Attribute">
                                </em>

                            </label>

                        </div>
                    </div>
                </div>
                <div class="row">


                    <div class="col-lg" style="margin-top: 10px;">
                        <mat-form-field appearance="outline">
                            <mat-label>Lifecycle</mat-label>
                            <mat-select formControlName="lifecycle" [(ngModel)]="jsuiteObjects.lifecycle">                       
                                <mat-option *ngFor="let item of lifecycleList" [value]="item.lifecycleId">                       
                                    {{item.lifecycleName}}
                                </mat-option>                   
                            </mat-select>                  
                        </mat-form-field>
                    </div>
                </div>

            </form>
        </div>

        <!-- Footer Buttons -->
        <div style="margin-top:40px;">
            <div class="row">
                <div class="col-lg text-center">
                    <div style="text-align: end;">
                        <form novalidate [formGroup]="formValidCheckbox">
                            <span *ngIf="showCreateAnother">
                                <mat-checkbox formControlName="isCheckboxSelected" [(ngModel)]="isCheckboxSelected"
                                    style="margin-right:1%" class="mat-checkbox-layout"></mat-checkbox>
                                <span>Create another</span>
                            </span>

                            <app-common-button label={{this.buttonName}} title={{this.buttonName}} [critical]="true"
                                [buttonId]="1111" width="110px" (clicked)="saveMethod()"
                                style="margin-left: 6px; margin-right: 6px">
                            </app-common-button>

                            <app-common-button label="Cancel" title="Cancel" [critical]="true" [buttonId]="1111"
                                width="110px" (clicked)="cancel()" style="margin-left: 6px; margin-right: 6px">
                            </app-common-button>


                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>